export default __webpack_public_path__ + "static/media/the-scream-square.0641df3f.jpg";